import React from 'react';

import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

const IfLoggedInTemplate = ({ user, children }) => {
    if (user.loggedIn) {
        return <>{children}</>;
    } else {
        return null;
    }
};

const IfLoggedIn = connect(mapStateToProps, mapDispatchToProps)(IfLoggedInTemplate);

export default IfLoggedIn;
